module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinnerLoader abs"
  }, [_c('Spinner', {
    staticClass: "loader",
    attrs: {
      "animation-duration": 5000,
      "size": 60,
      "color": '#41b4e8'
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ee9cb7f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Spinner.vue
// module id = 3066
// module chunks = 0